// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  BUTTON: '[data-is="ShowMorePhotos"]'
};

class ShowMorePhotos extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.button = document.querySelector(fragments.BUTTON);
  }

  didMount() {
    this.button.addEventListener('click', this.handleClick);
  }

  willUnMount() {
    this.button.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    let galleryItemHide = Array.from(document.getElementsByClassName('gallery__item--hide'));

    this.element.parentNode.removeChild(this.element);
    document.querySelector('.gallery__link--hide').classList.remove('gallery__link--hide');
    for (let element of galleryItemHide) {
      element.classList.remove('gallery__item--hide');
    }
  }
}

export default ShowMorePhotos;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ShowMorePhotos.js